exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renshou-sync-log .log-content[data-v-558ea509]{min-height:200px}", ""]);

// exports
